import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["align", "alignSortIconRight", "arrowsNode", "children"];
import styled, { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import { isIE11 } from '../../../utils/BrowserTest';
import { filterProps } from '../../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../../hooks/useMapTokenPropsToCSS';
import { useTableStyles } from '../Table.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSortIcon = styled.span.withConfig({
  displayName: "SortTH_Content__StyledSortIcon",
  componentId: "sc-1kw1l0g-0"
})(() => ({
  flexShrink: 0
}));
const LeftContent = styled.span.withConfig({
  displayName: "SortTH_Content__LeftContent",
  componentId: "sc-1kw1l0g-1"
})(() => ({
  flexGrow: 1
}));
const StyledContent = styled.div.withConfig({
  displayName: "SortTH_Content__StyledContent",
  componentId: "sc-1kw1l0g-2"
})(({
  $align,
  $cssStyles,
  $alignSortIconRight
}) => {
  const {
    tableHeaderHeight
  } = useTableStyles();
  return Object.assign({
    display: 'flex',
    alignItems: 'center'
  }, $align === 'right' && {
    marginLeft: 'auto',
    textAlign: 'right'
  }, $alignSortIconRight && {
    flexGrow: 1
  }, isIE11() && {
    height: tableHeaderHeight
  }, $cssStyles);
});
export const SortTH_Content = _ref => {
  let {
      align,
      alignSortIconRight,
      arrowsNode,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    callbackProps,
    restProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const theme = useTheme();
  const isTrellis = isTrellisTheme(theme);
  return /*#__PURE__*/_jsx(StyledContent, Object.assign({}, domProps, callbackProps, restProps, {
    $align: align,
    $alignSortIconRight: alignSortIconRight && isTrellis,
    $cssStyles: cssStyles,
    children: alignSortIconRight && isTrellis ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(LeftContent, {
        children: children
      }), /*#__PURE__*/_jsx(StyledSortIcon, {
        children: arrowsNode
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [children, arrowsNode]
    })
  }));
};